import { LinkList, SmallTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Social = ({ social }) => (
  <Layout>
    <SmallTitle>{social.title}</SmallTitle>
    <LinkList pages={social.pages} />
  </Layout>
)

Social.propTypes = {
  social: PropTypes.object.isRequired,
}

Social.defaultProps = {}

export default Social
